import React from 'react';
import PropTypes from 'prop-types';
import TextField from '@material-ui/core/TextField';
import Paper from '@material-ui/core/Paper';
import Fab from '@material-ui/core/Fab';
import AddIcon from '@material-ui/icons/Add';
import DateRangeIcon from '@material-ui/icons/DateRange';
import AccessTimeIcon from '@material-ui/icons/AccessTime';
import moment from 'moment';

import { DatePicker, TimePicker } from 'material-ui-pickers';
import ObjectSelect from '../../Common/ObjectSelect';

import styles from './styles';

const combineDateTime = (date, time) => {
  const result = moment(date).startOf('d');
  const time2 = moment(time);
  result.hours(time2.hours());
  result.minutes(time2.minutes());
  return result.toDate();
};

const validate = ({ date, from, to, quantity, role }, showError) => {
  console.log('valdate', date, from, to, quantity, role);

  // console.log('handleAddResource', this.state);
  // const { showError } = this.props;
  // TODO replace with form validation
  if (!date) {
    throw new Error('Please select a date');
  }
  if (!from) {
    throw new Error('Please select a start time');
  }
  if (!to) {
    throw new Error('Please select an end time');
  }
  // if (!this.state.quantity) {
  //   this.state.quantity = 1;
  // }
  if (!role) {
    throw new Error('Please select a role');
  }

  const start = combineDateTime(date, from);
  let end = combineDateTime(date, to);
  if (moment(end).isBefore(moment(start))) {
    end = moment(start).add(1, 'days').toDate();
  }

  const data = {
    from: start,
    to: end,
    quantity: quantity || 1,
    role: role,
  };

  return data;
};


class ResourceInput extends React.Component {
  state = {
    date: moment().add(1, 'd').toDate(),
    from: moment().add(1, 'd').hours(8).minutes(0).toDate(),
    to: moment().add(1, 'd').hours(17).minutes(0).toDate(),
    quantity: 1,
  };

  componentWillMount() {
    this.componentWillReceiveProps(this.props);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.fixedDate) {
      this.setState({
        date: nextProps.fixedDate,
      });
    }
  }

  reset() {
    this.setState({
      role: null,
      quantity: 1,
    });
  }

  render() {
    const { roles, fixedDate, showError } = this.props;
    const { date, from, to, quantity, role } = this.state;

    return (<Paper style={styles.row}>
      {!fixedDate ? <div style={styles.time}>
        <DateRangeIcon style={styles.icon}/>
        <DatePicker
          style={styles.dateInput}
          mode="landscape"
          label="Date"
          autoOk
          value={date}
          fullWidth
          onChange={(date) => this.setState({ date })}
        />
      </div> : null}
      <div style={styles.time}>
        <AccessTimeIcon style={styles.icon}/>
        <TimePicker
          style={styles.timeInput}
          label="Start"
          fullWidth
          autoOk
          value={from}
          onChange={(from) => this.setState({ from })}
        />
      </div>
      <div style={styles.time}>
        <AccessTimeIcon style={styles.icon}/>
        <TimePicker
          style={styles.timeInput}
          label="End"
          fullWidth
          value={to}
          autoOk
          onChange={(to) => this.setState({ to })}
        />
      </div>
      <div style={styles.fixedInput}>
        <TextField
          name="quantity"
          label="Quantity"
          value={quantity}
          style={styles.quantity}
          onChange={(evt) => this.setState({ quantity: evt.target.value })}
        />
      </div>
      <div style={styles.input}>
        {/*<RoleAutoComplete*/}
          {/*name="role"*/}
          {/*label="Role"*/}
          {/*style={styles.role}*/}
          {/*roles={roles || []}*/}
          {/*value={role}*/}
          {/*onChange={(role) => this.setState({ role })}*/}
        {/*/>*/}
        <ObjectSelect
          label="Role"
          fullWidth
          data={roles}
          value={role || ''}
          onChange={(role) => this.setState({ role })}
          display={(role) => role.name}
        />
      </div>
      <div>
        <Fab
          size="small"
          color="secondary"
          onClick={() => {
            try {
              const data = validate(this.state);
              this.props.onAdd(data);
              this.reset();
            } catch (err) {
              showError('Error', err.message);
            };

          }}
        >
          <AddIcon/>
        </Fab>
      </div>
    </Paper>);
  }
}

ResourceInput.propTypes = {
  // initialDate: PropTypes.object,
  // fetchRoles: PropTypes.func.isRequired,
  roles: PropTypes.array,
  fixedDate: PropTypes.object,
  onAdd: PropTypes.func.isRequired,
  showError: PropTypes.func.isRequired,
};

export default ResourceInput;

//
// export default reduxForm({
//   form: 'ResourceInput',  // a unique identifier for this form
//   // enableReinitialize: true,
//   onSubmit: (values, dispatch, props) => {
//     console.log('onSubmit');
//   }
// })(ResourceInput);

// function mapDispatchToProps(dispatch) {
//   return bindActionCreators({
//     showError,
//     fetchRoles: fetchRolesRoutine.trigger,
//   }, dispatch);
// }
//
// function mapStateToProps(state) {
//   return {
//     roles: toArray(state.get('roles').get('roles').toJS()).sort((a, b) => sortStrings(a.name, b.name)),
//   };
// }
//
// export default connect(mapStateToProps, mapDispatchToProps)(ResourceInput);



// WEBPACK FOOTER //
// ./src/components/Resources/ResourceInput/index.js